<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">车船基本信息详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%;"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="车船编号" prop="CarId">
                <el-input v-model="data.CarId" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车船名称" prop="CarName">
                <el-input v-model="data.CarName" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车船类型" prop="DeviceType">
                <el-select
                  v-model="data.DeviceType"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in DeviceTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌号" prop="PlateNo">
                <el-input v-model="data.PlateNo" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="SIM卡号" prop="SimNo">
                <el-input v-model="data.SimNo" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="核定载客数" prop="PassengerNumber">
                <el-input
                  v-model="data.PassengerNumber"
                  :disabled="!IsEdit"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="生产日期" prop="ProductDate">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="data.ProductDate"
                  type="date"
                  format="yyyy-MM-dd"
                  style="width: 100%;"
                  :disabled="!IsEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保养日期" prop="MaintainDate">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="data.MaintainDate"
                  type="date"
                  format="yyyy-MM-dd"
                  style="width: 100%;"
                  :disabled="!IsEdit"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="负责人" prop="Contactor">
                <el-input
                  v-model="data.Contactor"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人号码" prop="ContactPhone">
                <el-input
                  v-model="data.ContactPhone"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Expend1">
                <el-input
                  v-model="data.Expend1"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "CarShipManagerInfo",
  controller: "UI",
  action: "CarShipManagerInfo",
  data() {
    return {
      data: {
        DeviceType: "",
        ProductDate: new Date(),
        MaintainDate: new Date(),
      },

      DeviceTypeArr: [
        { value: "1", label: "车辆" },
        { value: "2", label: "游船" },
      ],
      IsEdit: false,
      rules: {
        CarId: [{ required: true, message: "请输入车船编号", trigger: "blur" }],
        CarName: [
          { required: true, message: "请输入车船名称", trigger: "blur" },
        ],
        DeviceType: [
          { required: true, message: "请选择车船类型", trigger: "change" },
        ],
        PassengerNumber: [
          {
            required: false,
            message: "请输入有效的核定载客数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/,
          },
        ],
      },
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          ID: InfoId,
        };
        new MyApis.TranResourcesApi()
          .GeItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.data = r;
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "车船基本信息修改";
            this.logInfo.LogMessage = r ? "车船基本信息修改成功" : "车船基本信息修改失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "车船基本信息详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          ID: uuid,
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "车船基本信息添加";
            this.logInfo.LogMessage =  r ? "车船基本信息添加成功" : "车船基本信息添加失败";
            this.logInfo.ModuleName = "车辆调度";
            this.logInfo.PageName = "车船基本信息详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
